import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

class DocumentoProcessoDigital {
	constructor(URL_PATH) {
		this.URL_PATH = URL_PATH
	}

	async buscarProcessoDigitalUrl(id) {
		return await axios.get(`${this.URL_PATH}/${id}/processo-digital`)
	}

	async buscarPorId(idDocumentoDigital) {
		return await axios.get(`${this.URL_PATH}/documentos/${idDocumentoDigital}/processo-digital`)
	}

	async baixarDocumentoProcessoDigital(idDocumento) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${this.URL_PATH}/documentos/${idDocumento}/processo-digital/download-impressao`,
		}).build()

		return await axios.get(url, {
			responseType: 'arraybuffer',
		})
	}

	async juntarLoteDocumentosProcessoDigital(payload) {
		return await axios.put(`${this.URL_PATH}/${payload.id}/documentos/processo-digital/juntar/lote`, {
			idsDocumentos: payload.idsDocumentos,
		})
	}

	async assinarEletronicamenteDocumentoProcessoDigital(idDocumento) {
		return await axios.post(`${this.URL_PATH}/documentos/${idDocumento}/processo-digital/assinatura-eletronica`)
	}

	async assinarDigitalmenteDocumentoProcessoDigital(idDocumento) {
		return await axios.post(`${this.URL_PATH}/documentos/${idDocumento}/processo-digital/assinatura-digital`)
	}

	async assinarEletronicamenteLoteDocumentoProcessoDigital(id, input) {
		return await axios.post(
			`${this.URL_PATH}/${id}/documentos/processo-digital/assinatura-eletronica/lote/iniciar`,
			input,
		)
	}

	async validarSeDocumentoAtaFoiAssinadoNoProcessoDigital(idDocumento) {
		return await axios.post(
			`${this.URL_PATH}/documentos/${idDocumento}/processo-digital/assinatura/validar-documento-assinado`,
		)
	}

	async cancelarDocumentoProcessoDigital(payload) {
		return await axios.post(`${this.URL_PATH}/documentos/${payload.idDocumento}/processo-digital/cancelar`, {
			motivoCancelamento: payload.motivo,
		})
	}
}

export default DocumentoProcessoDigital
